import React from "react";
import { Mail, HelpCircle } from "lucide-react";
import SettingsLayout from "./SettingsLayout";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { Logo } from "@/components/Logo";

const SUPPORT_EMAIL = "debiidev222@gmail.com";

const FAQS = [
  {
    q: "What is Debii?",
    a: "Debii is a personal debt and IOU tracking app that helps you keep track of money you lend or borrow.",
  },
  {
    q: "Does Debii lend money?",
    a: "No. Debii does not provide loans or hold users' money.",
  },
  {
    q: "How do I record a repayment?",
    a: "Open the relevant debt and select the option to record a repayment.",
  },
  {
    q: "What is Debii Plus?",
    a: "Debii Plus gives users access to additional features available under their subscription.",
  },
  {
    q: "How do I contact Debii?",
    a: `Email ${SUPPORT_EMAIL}.`,
  },
];

export default function HelpSettings() {
  const mailto = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent("Debii Support")}`;

  return (
    <SettingsLayout title="Help & Support" subtitle="Answers and how to reach us" testId="help-settings-page">
      <section>
        <p className="text-sm font-bold uppercase tracking-wide text-foreground flex items-center gap-2">
          <HelpCircle className="h-4 w-4 text-primary" /> Frequently asked questions
        </p>
        <Accordion type="single" collapsible className="mt-2 rounded-2xl border border-border bg-card px-4">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-sm font-semibold text-foreground text-left">{f.q}</AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>

      <section className="mt-6">
        <p className="text-sm font-bold uppercase tracking-wide text-foreground">Contact support</p>
        <a
          data-testid="contact-support-email"
          href={mailto}
          className="mt-2 flex items-center gap-3 rounded-2xl border border-border bg-card px-4 py-4 hover:bg-secondary/50"
        >
          <div className="h-10 w-10 rounded-full bg-secondary flex items-center justify-center shrink-0">
            <Mail className="h-5 w-5 text-primary" />
          </div>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-foreground">Email Debii Support</p>
            <p className="text-sm text-primary truncate">{SUPPORT_EMAIL}</p>
          </div>
        </a>
      </section>

      <section className="mt-6 rounded-2xl border border-border bg-card p-5">
        <p className="text-sm font-bold uppercase tracking-wide text-foreground mb-2">About Debii</p>
        <div className="flex items-center gap-2 mb-2"><Logo size={22} /></div>
        <p className="text-sm text-muted-foreground leading-relaxed">
          Debii helps you privately keep track of money you lend or borrow — who owes you, how much, and when
          they promised to pay. Debii is not a lender and does not hold your money.
        </p>
        <p className="mt-3 text-xs text-muted-foreground">Debii · Never forget who owes you.</p>
      </section>
    </SettingsLayout>
  );
}
